import { get, send } from "../api.js";

export type RetentionFollowUpCategory = "taster" | "cancellation" | "unused_credit";
export type RetentionFollowUpStatus = "open" | "dismissed" | "resolved";

export interface RetentionFollowUpCandidate {
  studentId: string;
  category: RetentionFollowUpCategory;
  evidenceAt: string;
}

export interface RetentionFamilyFollowUpEmailStatus {
  enabled: boolean;
  state?: "ready" | "no_opt_in" | "cooldown" | "already_queued" | "stale" | "resolved" | "unavailable";
  availableAt?: string;
}

export interface RetentionFollowUpState extends RetentionFollowUpCandidate {
  state: RetentionFollowUpStatus;
  note: string | null;
}

export const retentionFollowUpApi = {
  state: (candidate: RetentionFollowUpCandidate) =>
    get<Pick<RetentionFollowUpState, "state" | "note">>(
      "/admin/follow-up/retention-state",
      {
        studentId: candidate.studentId,
        category: candidate.category,
        evidenceAt: candidate.evidenceAt,
      },
    ),
  emailStatus: (candidate: RetentionFollowUpCandidate) =>
    get<RetentionFamilyFollowUpEmailStatus>("/admin/follow-up/retention-email", {
      studentId: candidate.studentId,
      category: candidate.category,
      evidenceAt: candidate.evidenceAt,
    }),
  queueFamilyEmail: (candidate: RetentionFollowUpCandidate) =>
    send<{ state: "queued" | "already_queued" | "cooldown"; availableAt?: string }>(
      "POST",
      "/admin/follow-up/retention-email",
      candidate,
    ),
  update: (
    input: RetentionFollowUpCandidate & {
      action: "dismiss" | "resolve" | "reopen";
      note: string | null;
    },
  ) =>
    send<Pick<RetentionFollowUpState, "state" | "note">>(
      "POST",
      "/admin/follow-up/retention-state",
      input,
    ),
};
